var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 32,
    viewBox: "0 0 14 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#909ca8",
    d: "M6.222 7.2h1.556v1.6H6.222zm3.111 0h1.556v1.6H9.333zm3.111 7.2v-8H1.556v8zM1.556 4.8h10.888V3.2H1.556zM14 3.2v11.2c0 .88-.7 1.6-1.556 1.6H1.556C.692 16 0 15.28 0 14.4L.008 3.2c0-.88.684-1.6 1.548-1.6h.777V0H3.89v1.6h6.222V0h1.556v1.6h.777C13.3 1.6 14 2.32 14 3.2zm-10.889 4h1.556v1.6H3.11z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#909ca8",
    d: "M6.222 10.2h1.556v1.6H6.222zm3.111 0h1.556v1.6H9.333zm-6.222 0h1.556v1.6H3.11z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.4e682021b3ccfe3e8045c7c0a5efbd65.svg";
export { ForwardRef as ReactComponent };